import React, { useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import cx from "classnames";
import { Switch, Route, Redirect, Router, useHistory } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AdminNavbar from "beaktShared/components/Navbars/AdminNavbar.js";
import Footer from "beaktShared/components/Footer/Footer.js";
import Sidebar from "beaktShared/components/Sidebar/Sidebar.js";
import routes_before from "beaktAdmin/routesadmin";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import { getTokenCookie } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import ComunicadoBlockOverlay from "beaktShared/components/Comunicado/ComunicadoBlockOverlay";

var ps;

const useStyles = makeStyles(styles);

export default function Admin(props) {
  const history = useHistory();
  const { t } = useTranslation();
    
  const [session] = useState(getSessionCookie());
  const [routes, setroutes] = React.useState([]);

  useEffect(() => {
    
    if(validateToken("") === true)
      getRoutesApi();   
  
  },[]);

  useEffect(() => {
    setInterval(() => {
      validateToken(history.location.pathname);
    },3000);
    
   },[history.location.pathname]);

  const validateToken = (activeRoute) => {
    if (session != null && session.tipoPerfil != 0)
    {
      props.history.push("/auth/login");
      return false;      
    }
    
    var token = getTokenCookie();

    if (session === null || token === null) {
      props.history.push("/auth/login");
      return false;
    }
    
    if (token.expired)
      props.history.push("/auth/login");  
    
    return true;
  }  
   
  const getRoutesApi = () =>
  {
    let routes_menu = routes_before;
    setroutes(routes_menu);    
  }
    
  const { ...rest } = props;
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  // const [image] = React.useState(require("assets/img/sidebar-2.jpg"));
  const [color] = React.useState("blue");
  const [bgColor] = React.useState("black");
  // const [hasImage, setHasImage] = React.useState(true);
  const [logo] = React.useState(require("assets/img/logotipo-white-clinic.png"));
  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });

  const sendScrollToTOP = () =>{
    const container = document.querySelector('#divscroll');
    container.scrollTop = 0;
  }

  // functions for changeing the states from components
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getActiveRoute = routes => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getRoutes = (routes) => {        
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      } 
            
      return (
        <Route
          path={prop.layout + prop.path}                    
          render={(props) =>  (<prop.component callUpdateScrollTOP={sendScrollToTOP}  history={props.history} />)} 
          key={key}          
        />
      );     
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  
  return (
    
  <SessionContext.Provider value={session}>
    {/* Bloqueio global enquanto houver comunicado pendente de aceite (BKT-1594) */}
    {session && <ComunicadoBlockOverlay history={props.history} />}

    <div className={classes.wrapper}>
      <Sidebar
        history={props.history}
        routes={routes}
        logoText={"Admin"}
        logo={logo}
        redirectlogo={"/admin/home"}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        bgColor={bgColor}
        miniActive={miniActive}
        session={session}
        pathMainUrl="admin"
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel} id="divscroll">
        <AdminNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          brandText={getActiveRoute(routes) === "" ? "" :t('sidebar.'+getActiveRoute(routes))}
          handleDrawerToggle={handleDrawerToggle}  
          history={props.history}
          pathMainUrl="admin"    
          {...rest}
        />
        
          <div className={classes.content}>
            <div className={classes.container} className="allowPrint">
                <Switch>
                  {getRoutes(routes)}
                  {/* Comentei esse codigo, pois sempre que aperta o f5 encaminhava pra home.. ao inves de atualizar a tela atual
                  <Redirect from="/adminclinic" to="/adminclinic/home" />*/}
                </Switch> 
            </div>
          </div>

        <Footer fluid /> 
      </div>
    </div>
    </SessionContext.Provider>    
  );
}
